import { Routes, Route } from "react-router-dom";
import Dashboard from '../pages/StudentDashboard/Dashboard.js';
import Applications from '../components/Applications/index.js';
import EditProfile from '../components/EditProfile/index.js';
import Layout from "../layout/index.js";
import ReportDashboard from "../components/Reports/index.js";
import VendorPayments from "../pages/FinanceDashboard/VendorPyaments.js";
import VendorApplications from "../pages/FinanceDashboard/VendorApplications.js";
import ChangePassword from "../components/ChangePassword/index.js";

const routes = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "partner-payment", element: <VendorPayments />, text: "Partner Payments" },
  { path: "partner-applications", element: <VendorApplications />, text: "Partner Applications" },
  { path: "reports", element: <ReportDashboard />, text: "Reports" },
];

const FinanceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout navItems={routes} />}>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} /> 
      </Route>
    </Routes>
  );
};

export default FinanceRoutes;